// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { COLORS } from 'Components/utils/color/colors';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
import { TripAdvisor } from 'Components/widgets/tripadvisor/TripAdvisor';

type Props = {|
  tripadvisor: {
    awards: Array<{
      displayName: string,
      images: {
        large: string,
      },
    }>,
    numReviews: string,
    rating: string,
    ratingImageUrl: string,
    reviews: Array<{
      title: string,
      text: string,
      url: string,
      rating: number,
      ratingImageUrl: string,
      reviewDate: string,
      reviewAuthor: Array<string>,
      publishedDate: string,
    }>,
    subratings: Array<{
      localizedName: string,
      ratingImageUrl: string,
      value: number,
    }>,
    tripAdvisorUrl: string,
  },
  tripAdvisorLineTitle: string,
  tripAdvisorViewMoreLabel: string,
  awards: string,
  basedOn: string,
  ratings: string,
  ratingTitle: string,
  reviews: string,
|};

export const ProductTripAdvisorLine = (props: Props) => {
  const { tripadvisor } = props;

  const { isDesktop } = useContext(ResponsiveContext);

  if (!tripadvisor || !tripadvisor.tripAdvisorUrl) {
    return null;
  }

  const awards = tripadvisor.awards.map(({ displayName, images = {} }) => ({
    altMsg: displayName,
    imageUrl: images.large,
  }));

  const awardsLabel = props.awards;

  const ratings = {
    counterLabel: props.basedOn,
    counterUnit: props.reviews,
    counterValue: tripadvisor.numReviews,
    image: {
      altMsg: tripadvisor.rating,
      imageUrl: tripadvisor.ratingImageUrl,
    },
    subratings: tripadvisor.subratings,
    title: props.ratingTitle,
  };
  const ratingsLabel = props.ratings;
  const reviews = tripadvisor.reviews.map(review => ({
    authors: review.reviewAuthor,
    date: review.reviewDate,
    datetime: review.publishedDate,
    rating: review.rating,
    ratingImageUrl: review.ratingImageUrl,
    text: review.text,
    title: review.title,
    url: review.url,
  }));
  const reviewsLabel = props.reviews;
  const { tripAdvisorUrl } = tripadvisor;
  const { tripAdvisorLineTitle, tripAdvisorViewMoreLabel } = props;

  return (
    <SiteContainer className="Line" id="tripadvisor">
      <div className="relative">
        <LineTitle>{tripAdvisorLineTitle}</LineTitle>
        {isDesktop ? (
          <TextLink
            className="absolute rtl:right-0 top-0"
            color={COLORS.GRAY_DARKER}
            iconRightName={null}
            label={tripAdvisorViewMoreLabel}
            theme="simple"
            url={tripAdvisorUrl}
            trackingData={{
              categoryGA: 'resort',
              actionGA: 'practicalInfos',
              labelGA: 'tripAdvisorSeeMore',
            }}
          />
        ) : null}
      </div>
      <TripAdvisor
        awards={awards}
        awardsLabel={awardsLabel}
        ratings={ratings}
        ratingsLabel={ratingsLabel}
        reviews={reviews}
        reviewsLabel={reviewsLabel}
      />
    </SiteContainer>
  );
};
